export enum MapsClickEventType {
	USER,
	MARKER,
	POLYGON,
}
